import React from "react";

const Card = ({ className, children, ...props }) => {
  return (
    <div
      className={`bg-white rounded-lg border border-gray-200 shadow-md overflow-hidden ${className || ""}`}
      {...props}
    >
      {children}
    </div>
  );
};

const CardHeader = ({ className, children, ...props }) => {
  return (
    <div className={`p-4 border-b border-gray-200 ${className || ""}`} {...props}>
      {children}
    </div>
  );
};

const CardTitle = ({ className, children, ...props }) => {
  return (
    <h3 className={`text-xl font-bold text-gray-800 ${className || ""}`} {...props}>
      {children}
    </h3>
  );
};

const CardContent = ({ className, children, ...props }) => {
  return (
    <div className={`p-4 ${className || ""}`} {...props}>
      {children}
    </div>
  );
};

export { Card, CardHeader, CardTitle, CardContent }; 